import {
    FETCH_LANG_CUSTOMER_FOCUS_SUCCESS,
} from '../constants/ActionTypes';

const initialState = {
    langCustomerFocus: {
        visitingResult: "ผลการเข้าเยี่ยม",
        planVisit: "มีแผนและได้เข้าเยี่ยม",
        planNoVisit: "มีแผนแต่ไม่ได้เข้าเยี่ยม",
        noPlanVisit: "ไม่มีแผนแต่ได้เข้าเยี่ยม",
        noPlanNoVisit: "ไม่มีแผนและไม่ได้เข้าเยี่ยม",
        avgSalesPerVisit: "ยอดขายเฉลี่ยที่ทำได้ต่อการเยี่ยม",
        salesNumOfVisit: "เข้าเยี่ยมกี่ครั้งถึงขายได้",
        avgSalesPerBill: "ยอดขายเฉลี่ยต่อบิล",
        yearOrderAmt: "ยอดขายปีนี้",
        monthOrderAmt: "ยอดขายเดือนนี้",
        activity: "กิจกรรม",
        number: "ลำดับ",
        salesmanName: "ชื่อเซลล์",
        date: "วันที่",
        type: "ประเภท",
        detail: "รายละเอียด",
        overdueBill: "บิลค้างชำระ",
        dueDate: "วันกำหนดชำระ",
        billNo: "เลขที่บิล",
        invNo: "เลขที่ใบกำกับ",
        debtAmount: "จำนวนเงินคงค้าง",
        status: "สถานะ",
        productStock: "Stockcard",
        product: "สินค้า",
        forward: "ยกมา",
        buy: "ขายเข้า",
        sale: "ยอดระบาย",
        salesHistory: "ประวัติการขาย",
        display: "รูปแบบ",
        itemGroup: "หมวดสินค้า",
        productGroup: "กลุ่มสินค้า",
        productLine: "ประเภทสินค้า",
        productCode: "สินค้า",
        numberType: "จำนวน",
        sellingProportion: "สัดส่วนที่ขายเดือนปัจจุบัน",
        productNotBuy: "สินค้าที่ไม่ได้ซื้อเดือนปัจจุบัน",
        productOrder: "รอบการสั่งสินค้า",
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LANG_CUSTOMER_FOCUS_SUCCESS:
            return {
                ...state,
                langCustomerFocus: {
                    visitingResult: action.payload.visitingResult 
                        ? action.payload.visitingResult : initialState.langCustomerFocus.visitingResult,
                    planVisit: action.payload.planVisit 
                        ? action.payload.planVisit : initialState.langCustomerFocus.planVisit,
                    planNoVisit: action.payload.planNoVisit 
                        ? action.payload.planNoVisit : initialState.langCustomerFocus.planNoVisit,
                    noPlanVisit: action.payload.noPlanVisit 
                        ? action.payload.noPlanVisit : initialState.langCustomerFocus.noPlanVisit,
                    noPlanNoVisit: action.payload.noPlanNoVisit 
                        ? action.payload.noPlanNoVisit : initialState.langCustomerFocus.noPlanNoVisit,
                    avgSalesPerVisit: action.payload.avgSalesPerVisit 
                        ? action.payload.avgSalesPerVisit : initialState.langCustomerFocus.avgSalesPerVisit,
                    salesNumOfVisit: action.payload.salesNumOfVisit 
                        ? action.payload.salesNumOfVisit : initialState.langCustomerFocus.salesNumOfVisit,
                    avgSalesPerBill: action.payload.avgSalesPerBill 
                        ? action.payload.avgSalesPerBill : initialState.langCustomerFocus.avgSalesPerBill,
                    yearOrderAmt: action.payload.yearOrderAmt 
                        ? action.payload.yearOrderAmt : initialState.langCustomerFocus.yearOrderAmt,
                    monthOrderAmt: action.payload.monthOrderAmt 
                        ? action.payload.monthOrderAmt : initialState.langCustomerFocus.monthOrderAmt,
                    activity: action.payload.activity 
                        ? action.payload.activity : initialState.langCustomerFocus.activity,
                    number: action.payload.number 
                        ? action.payload.number : initialState.langCustomerFocus.number,
                    salesmanName: action.payload.salesmanName 
                        ? action.payload.salesmanName : initialState.langCustomerFocus.salesmanName,
                    date: action.payload.date 
                        ? action.payload.date : initialState.langCustomerFocus.date,
                    type: action.payload.type 
                        ? action.payload.type : initialState.langCustomerFocus.type,
                    detail: action.payload.detail 
                        ? action.payload.detail : initialState.langCustomerFocus.detail,
                    overdueBill: action.payload.overdueBill 
                        ? action.payload.overdueBill : initialState.langCustomerFocus.overdueBill,
                    dueDate: action.payload.dueDate 
                        ? action.payload.dueDate : initialState.langCustomerFocus.dueDate,
                    billNo: action.payload.billNo 
                        ? action.payload.billNo : initialState.langCustomerFocus.billNo,
                    invNo: action.payload.invNo 
                        ? action.payload.invNo : initialState.langCustomerFocus.invNo,
                    debtAmount: action.payload.debtAmount 
                        ? action.payload.debtAmount : initialState.langCustomerFocus.debtAmount,
                    status: action.payload.status 
                        ? action.payload.status : initialState.langCustomerFocus.status,
                    productStock: action.payload.productStock 
                        ? action.payload.productStock : initialState.langCustomerFocus.productStock,
                    product: action.payload.product 
                        ? action.payload.product : initialState.langCustomerFocus.product,
                    forward: action.payload.forward 
                        ? action.payload.forward : initialState.langCustomerFocus.forward,
                    buy: action.payload.buy 
                        ? action.payload.buy : initialState.langCustomerFocus.buy,
                    sale: action.payload.sale 
                        ? action.payload.sale : initialState.langCustomerFocus.sale,
                    salesHistory: action.payload.salesHistory 
                        ? action.payload.salesHistory : initialState.langCustomerFocus.salesHistory,
                    display: action.payload.display 
                        ? action.payload.display : initialState.langCustomerFocus.display,
                    itemGroup: action.payload.itemGroup 
                        ? action.payload.itemGroup : initialState.langCustomerFocus.itemGroup,
                    productGroup: action.payload.productGroup 
                        ? action.payload.productGroup : initialState.langCustomerFocus.productGroup,
                    productLine: action.payload.productLine 
                        ? action.payload.productLine : initialState.langCustomerFocus.productLine,
                    productCode: action.payload.productCode 
                        ? action.payload.productCode : initialState.langCustomerFocus.productCode,
                    numberType: action.payload.numberType 
                        ? action.payload.numberType : initialState.langCustomerFocus.numberType,
                    sellingProportion: action.payload.sellingProportion 
                        ? action.payload.sellingProportion : initialState.langCustomerFocus.sellingProportion,
                    productNotBuy: action.payload.productNotBuy 
                        ? action.payload.productNotBuy : initialState.langCustomerFocus.productNotBuy,
                    productOrder: action.payload.productOrder 
                        ? action.payload.productOrder : initialState.langCustomerFocus.productOrder,
                }
            }
        default:
            return state;
    }
}
